<script>

    let cars = [];

    export function setup(data) {
        cars = data.cars;
    }

</script>

cars